<template>
  <div class="bg" v-show="show">
    <div class="wrapper">
      <div class="header">
        <span>警示提示</span>
      </div>
      <div class="body">
        <textarea class="content" v-model="content.msg" :maxlength="maxlength" placeholder="请输入警示文字"></textarea>
        <p class="count">{{`${content.msg.length} / ${maxlength}`}}</p>
      </div>
      <div class="footer">
        <p :class="{btn: true, green: true, disabled: disabled}" @click="confirm()">提交</p>
        <p class="btn" @click="cancel()">取消</p>
      </div>
    </div>
  </div>
</template>

<script>
import common from '@common/common'
import {apis} from '@common/config'

export default {
  name: 'success',
  data() {
    return {
      show: true,
      content: {
        id: 0,
        type: 0,
        msg: ''
      },
      maxlength: 60,
      r: null,
      disabled: false,
      startEmpty: false
    }
  },
  watch: {
    content: {
      deep: true,
      handler: function(n, o) {
        if (n.msg) {
          this.disabled = false
        } else {
          if (this.startEmpty) {
            this.disabled = true
          }
        }
      }
    }
  },
  methods: {
    open(content, r) {
      window.document.body.style.overflowY = 'hidden'
      this.content = content
      if (!this.content.msg) {
        this.startEmpty = true
        this.disabled = true
      }
      this.r = r
      this.show = true
    },
    close() {
      window.document.body.style.overflowY = 'auto'
      this.show = false
    },
    async confirm() {
      if (this.disabled) return
      if (!this.content.msg) {
        let c = await this.$confirm('警示内容为空，将删除警示')
        if (!c) return
      }

      const info = {
        subject_id: this.content.id,
        subject_type: this.content.type,
        info: this.content.msg
      }

      common.myFetch(apis.warn_add, info)
      .then((res) => {
        if (res) {
          this.$toast(res)
          this.r(true)
        }

        this.close()
      })
    },
    cancel() {
      this.r(null)
      this.close()
    }
  }
}
</script>

<style lang="less" scoped>
  @import '../../assets/css/global.less';
  .bg {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.70);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1222;
  }
  .wrapper {
    height: 300px;
    width: 700px;
    background-color: @bg;
    box-shadow: 4px 4px 10px 0 rgba(5, 10, 15, 0.05);
    border-radius: 4px;
    z-index: 5;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 20px 30px;
    .header {
      height: 34px;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 24px;
      font-weight: bold;
    }
    .body {
      margin: 20px 0;
      flex: 1;
      overflow: hidden;
      position: relative;
      border: 1px solid #dcdcdc;
      border-radius: 8px;
      padding: 15px 20px;
      .content {
        width: 100%;
        height: 100%;
        resize: none;
        font-size: 16px;
        background-color: transparent;
        &::placeholder {
          color: #ccc;
        }
      }
      .count {
        position: absolute;
        color: #ccc;
        font-size: 16px;
        right: 16px;
        bottom: 12px;
      }
    }
    .footer {
      height: 40px;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .close {
      cursor: pointer;
    }
    .btn {
      background-color: @dateColor;
      width: 120px;
      text-align: center;
      line-height: 40px;
      height: 40px;
      border-radius: 100px;
      color: #fff;
      font-size: 14px;
      box-shadow: 2px 1px 8px 0 rgba(0, 0, 0, 0.1);
      cursor: pointer;
      &:hover {
        .btnHover;
      }
      &:active {
        .btnActive;
      }
    }
    .green {
      margin-right: 40px;
      color: #fff;
      background-color: @green;
    }
    .disabled {
      cursor: not-allowed;
      color: #fff !important;
      background-color: @dateColor !important;
    }
  }
</style>
